import { Pipe, PipeTransform } from '@angular/core';

@Pipe({standalone: true,  name: 'default' })
export class DefaultPipe implements PipeTransform {
    private static testEmpty(value:any) {
        return '' === value || false === value || null === value || value?.[0] === undefined;
    }

    public transform(value: any, defaultToReturn: number|string = ''): number|string {
        if (DefaultPipe.testEmpty(value)) {
            return defaultToReturn;
        }

        return value;
    }
}
